package com.ijoin.data.repository

import com.ijoin.data.api.ConnectApi
import com.ijoin.data.model.ConnectAccountStatus
import com.ijoin.data.model.ConnectDashboardLinkResponse
import com.ijoin.data.model.ConnectOnboardingLinkResponse
import com.ijoin.data.model.PayoutMode

class ConnectRepository(
    private val connectApi: ConnectApi = ConnectApi()
) {
    suspend fun getConnectStatus(): Result<ConnectAccountStatus> =
        connectApi.getConnectStatus()

    suspend fun createOnboardingLink(
        refreshUrl: String,
        returnUrl: String
    ): Result<ConnectOnboardingLinkResponse> =
        connectApi.createOnboardingLink(refreshUrl, returnUrl)

    suspend fun getDashboardLink(): Result<ConnectDashboardLinkResponse> =
        connectApi.getDashboardLink()

    suspend fun enableDirectPayments(): Result<ConnectAccountStatus> =
        connectApi.switchPayoutMode(PayoutMode.DIRECT_CONNECT.name)

    suspend fun switchToPlatform(): Result<ConnectAccountStatus> =
        connectApi.switchPayoutMode(PayoutMode.PLATFORM_MERCHANT.name)

    suspend fun disconnect(): Result<ConnectAccountStatus> =
        connectApi.disconnect()
}
